/**
 * LoadingSpinner used as placeholder for loading component,
 * and with React Lazy -> Suspense
 *
 * @example
 * import LoadingSpinner from '@/components-temp/LoadingSpinner';
 * import { lazy, Suspense } from 'react';
 *
 * // Inside component
 * <Suspense fallback={<LoadingSpinner />}>
 *  ...
 * </Suspense>
 */
export const LoadingSpinner = ({ text }: { text?: string }) => {
  return (
    <div className='flex h-screen items-center justify-center'>
      <div className='relative flex flex-col items-center gap-3'>
        <div className='h-12 w-12 animate-spin rounded-full border-3 border-slate-200 border-t-blue-600' />
        {text && <p className='text-gray-600'>{text}</p>}
      </div>
    </div>
  );
};
